<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <v-row>
                    <v-col class="col-12 col-md-5">
                      <h1 class="primary-color">Virtual Profilers</h1>
                    </v-col>
                    <v-spacer />
                    <v-col class="col-12 col-md-2">
                      <v-btn class="new-item-btn float-right" block @click="openCreateProfiler">
                        <v-icon size="20">mdi-plus</v-icon>
                        &nbsp;&nbsp;Create virtual profiler
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-alert
                  v-if="messageCreateProfiler"
                  outlined
                  :color="successfullCreateProfiler ? 'success' : 'error'"
                  :icon="successfullCreateProfiler ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreateProfiler }}
                </v-alert>
                <v-alert
                  v-if="messageAssignProfiler"
                  outlined
                  :color="successfullAssignProfiler ? 'success' : 'error'"
                  :icon="successfullAssignProfiler ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageAssignProfiler }}
                </v-alert>
                <v-alert
                  v-if="messageUnassignProfiler"
                  outlined
                  :color="successfullUnassignProfiler ? 'success' : 'error'"
                  :icon="successfullUnassignProfiler ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageUnassignProfiler }}
                </v-alert>
                <v-data-table
                  :headers="headers"
                  :items="profilers"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait..."
                  :server-items-length="pagination.totalItems"
                  :items-per-page="pagination.itemsPerPage"
                  :page.sync="pagination.page"
                  item-class="text-wrap"
                  @update:page="handlePageChange"
                >
                  <template #[`item.character`]="{ item }">
                    <p v-if="item.character" class="mb-0">
                      {{ item.character }}
                    </p>
                    <p v-else class="mb-0">-</p>
                  </template>
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openShowDetails(item)">
                          <v-icon size="20" color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Show details</span>
                    </v-tooltip>

                    <v-tooltip v-if="user.profilerId !== null && item.id === user.profilerId" top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="unassignProfiler(item)">
                          <v-icon size="20" color="red">mdi-account-remove-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Unassign me virtual profiler</span>
                    </v-tooltip>
                    <v-tooltip v-else top>
                      <template #activator="{ on }">
                        <v-btn
                          icon
                          :disabled="someAssigned"
                          v-on="on"
                          @click="assignProfiler(item)"
                        >
                          <v-icon size="20" color="primary">mdi-account-plus-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Assign me virtual profiler</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-alert
              v-if="messageProfilers"
              class="mt-4"
              outlined
              :color="successfullProfilers ? 'success' : 'error'"
              :icon="successfullProfilers ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageProfilers }}
            </v-alert>
            <v-alert
              v-if="messageVoices"
              class="mt-4"
              outlined
              :color="successfullVoices ? 'success' : 'error'"
              :icon="successfullVoices ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageVoices }}
            </v-alert>
            <v-alert
              v-if="messageOptions"
              class="mt-4"
              outlined
              :color="successfullOptions ? 'success' : 'error'"
              :icon="successfullOptions ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageOptions }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createProfilerDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="createProfilerForm" @submit.prevent="createProfiler">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create Virtual Profiler</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="profiler.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="profiler.description"
                    class="py-0 mb-6 no-border-radius"
                    label="Description *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-textarea
                    v-model="profiler.systemPrompt"
                    class="py-0 mb-6 no-border-radius"
                    label="System prompt *"
                    :rules="rules"
                    rows="5"
                    no-resize
                    dense
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-select
                    v-model="profiler.STTapi"
                    class="py-0 mb-6 no-border-radius"
                    :items="options.sttObjs"
                    item-text="name"
                    item-value="id"
                    label="STT API *"
                    :rules="rules"
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-select
                    v-model="profiler.NLGapi"
                    class="py-0 mb-6 no-border-radius"
                    :items="options.nlgObjs"
                    item-text="name"
                    item-value="id"
                    label="NLG API *"
                    :rules="rules"
                  />
                </v-col>
                <v-col v-if="profiler.NLGapi !== null" cols="12" class="py-0">
                  <v-select
                    v-model="profiler.NLGModel"
                    class="py-0 mb-6 no-border-radius"
                    :items="options.nlgModels"
                    item-text="name"
                    item-value="id"
                    label="NLG Model *"
                    :rules="rules"
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-select
                    v-model="profiler.TTSapi"
                    class="py-0 mb-6 no-border-radius"
                    :items="options.ttsObjs"
                    item-text="name"
                    item-value="id"
                    label="TTS API *"
                    :rules="rules"
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-select
                    v-model="profiler.character"
                    class="py-0 mb-6 no-border-radius"
                    :items="characters"
                    item-text="name"
                    item-value="id"
                    label="Character *"
                    :rules="rules"
                    :disabled="!profiler.TTSapi"
                  />
                </v-col>
              </v-row>
              <v-alert
                v-if="messageCreateProfilerInside"
                class="mb-0 mt-8"
                outlined
                :color="successfullCreateProfilerInside ? 'success' : 'error'"
                :icon="successfullCreateProfilerInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageCreateProfilerInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreateProfiler"> Cancel </v-btn>
            <v-btn v-if="!creatingProfiler" type="submit" class="ok-modal"> Create </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDetailsProfilerDialog" max-width="800">
      <v-card>
        <v-form ref="detailsProfilerForm">
          <v-card-title class="px-6">
            <h5 class="primary-color">Details</h5>
          </v-card-title>
          <v-card-text class="pb-0 mt-4">
            <v-container>
              <v-row>
                <v-col cols="2">
                  <h6 class="details-subtitles primary-color">Name:</h6>
                </v-col>
                <v-col cols="10">
                  <p class="mb-0">{{ itemToShow.name }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <h6 class="details-subtitles primary-color">Description:</h6>
                </v-col>
                <v-col cols="10">
                  <p class="mb-0">{{ itemToShow.descripcion }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <h6 class="details-subtitles primary-color">System Prompt:</h6>
                </v-col>
                <v-col cols="10">
                  <p class="mb-0">{{ itemToShow.systemPrompt }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <h6 class="details-subtitles primary-color">STT API:</h6>
                </v-col>
                <v-col cols="10">
                  <p class="mb-0">{{ itemToShow.STTapi }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <h6 class="details-subtitles primary-color">NLG API:</h6>
                </v-col>
                <v-col cols="10">
                  <p class="mb-0">{{ itemToShow.NLGapi }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <h6 class="details-subtitles primary-color">NLG Model:</h6>
                </v-col>
                <v-col cols="10">
                  <p class="mb-0">{{ itemToShow.NLGModel }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <h6 class="details-subtitles primary-color">TTS API:</h6>
                </v-col>
                <v-col cols="10">
                  <p class="mb-0">{{ itemToShow.TTSapi }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <h6 class="details-subtitles primary-color">Character:</h6>
                </v-col>
                <v-col cols="10">
                  <p class="mb-0">{{ itemToShow.character }}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="showDetailsProfilerDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VirtualProfilersDataService from '@/services/VirtualProfilersDataService';

export default {
  name: 'VirtualProfilersList',
  data() {
    return {
      profilers: [],
      successfullProfilers: false,
      messageProfilers: '',
      voices: [],
      successfullVoices: false,
      messageVoices: '',
      options: [],
      successfullOptions: false,
      messageOptions: '',
      characters: [],
      loading: false,
      successfullCreateProfiler: false,
      messageCreateProfiler: '',
      successfullCreateProfilerInside: false,
      messageCreateProfilerInside: '',
      successfullAssignProfiler: false,
      messageAssignProfiler: '',
      successfullUnassignProfiler: false,
      messageUnassignProfiler: '',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'STT API', value: 'STTapi', sortable: false },
        { text: 'NLG API', value: 'NLGapi', sortable: false },
        { text: 'NLG Model', value: 'NLGModel', sortable: false },
        { text: 'TTS API', value: 'TTSapi', sortable: false },
        { text: 'Character', value: 'character', sortable: false },
        { text: 'Created at', value: 'createdAt', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      profiler: {
        name: '',
        description: '',
        systemPrompt: '',
        STTapi: null,
        NLGapi: null,
        TTSapi: null,
        character: null,
      },
      rules: [(v) => !!v || 'Required field'],
      createProfilerDialog: false,
      creatingProfiler: false,
      itemToShow: {},
      showDetailsProfilerDialog: false,
      someAssigned: false,
      user: {},
    };
  },
  watch: {
    'profiler.TTSapi'() {
      if (this.profiler.TTSapi !== null) {
        this.characters = this.voices.filter((voice) => voice.service === this.profiler.TTSapi);
      } else {
        this.characters = [];
      }
    },
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));
    await this.getAllProfilers(1);
    await this.getAllVoices();
    await this.getOptions();
  },
  methods: {
    getAllProfilers(page) {
      this.loading = true;

      VirtualProfilersDataService.findAll(page, this.pagination.itemsPerPage).then(
        (response) => {
          if (response.status == 200) {
            this.profilers = response.data.data;

            if (this.user.profilerId !== null) this.someAssigned = true;
            else this.someAssigned = false;

            if (this.profilers.length !== 0) {
              this.pagination.page = page;
              this.pagination.totalPages = response.data.links.totalPages || 1;

              this.pagination.totalItems =
                response.data.links.totalItems ||
                this.pagination.totalPages * this.pagination.itemsPerPage;
            }
          } else {
            this.successfullProfilers = false;
            this.messageProfilers =
              'An error has occurred retrieving the list of virtual profilers. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullProfilers = false;
          this.messageProfilers =
            'An error has occurred retrieving the list of virtual profilers. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.getAllProfilers(newPage);
    },
    getAllVoices() {
      this.loading = true;

      VirtualProfilersDataService.findAllVirtualProfilerVoices().then(
        (response) => {
          if (response.status == 200) {
            this.voices = response.data.data;

            this.profilers.forEach((profiler) => {
              const character = this.voices.find((voice) => voice.id === profiler.character);

              if (character !== undefined) profiler.character = character.name;
              else profiler.character = null;
            });
          } else {
            this.successfullVoices = false;
            this.messageVoices =
              'An error has occurred retrieving the list of voices. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullVoices = false;
          this.messageVoices =
            'An error has occurred retrieving the list of voices. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    getOptions() {
      this.loading = true;

      VirtualProfilersDataService.findFormOptions().then(
        (response) => {
          if (response.status == 200) {
            this.options = response.data.data;

            this.options.nlgObjs = [];
            this.options.ttsObjs = [];
            this.options.sttObjs = [];

            // this.options already has nlg, stt, tts properties directly from response.data.data
            this.options.nlg.forEach((item) => {
              const obj = {
                id: item,
                name: item,
              };
              this.options.nlgObjs.push(obj);
            });

            this.options.tts.forEach((item) => {
              const obj = {
                id: item,
                name: item,
              };
              this.options.ttsObjs.push(obj);
            });

            this.options.stt.forEach((item) => {
              const obj = {
                id: item,
                name: item,
              };
              this.options.sttObjs.push(obj);
            });

            VirtualProfilersDataService.findProfilerModels().then(
              (response) => {
                if (response.status == 200) {
                  const models = response.data;

                  this.options.nlgModels = [];

                  if (models && Array.isArray(models)) {
                    models.forEach((model) => {
                      const obj = {
                        id: model,
                        name: model,
                      };

                      this.options.nlgModels.push(obj);
                    });
                  } else {
                    console.warn('Models data is not available or not an array:', models);
                  }
                } else {
                  this.successfullOptions = false;
                  this.messageOptions =
                    'An error has occurred retrieving the form options. Please, try again later.';
                }

                this.loading = false;
              },
              (error) => {
                this.successfullOptions = false;
                this.messageOptions =
                  'An error has occurred retrieving the form options. Please, try again later.';

                console.error(
                  (error.response && error.response.data) || error.message || error.toString()
                );

                if (error.response.status === 401 || error.response.status === 403) {
                  localStorage.removeItem('user');
                  this.$router.push('/');
                }

                this.loading = false;
              }
            );
          } else {
            this.successfullOptions = false;
            this.messageOptions =
              'An error has occurred retrieving the form options. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullOptions = false;
          this.messageOptions =
            'An error has occurred retrieving the form options. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    openCreateProfiler() {
      this.createProfilerDialog = true;
      this.profiler = {
        name: '',
        description: '',
        systemPrompt: '',
        STTapi: null,
        NLGapi: null,
        TTSapi: null,
        character: null,
      };
    },
    createProfiler() {
      this.successfullCreateProfiler = true;
      this.messageCreateProfiler = '';

      if (this.$refs.createProfilerForm.validate()) {
        this.creatingProfiler = true;

        VirtualProfilersDataService.create(this.profiler).then(
          (response) => {
            if (response.status == 201) {
              this.getAllProfilers(1);

              this.messageCreateProfiler = '';
              this.successfullCreateProfiler = true;

              setTimeout(() => {
                this.messageCreateProfiler = 'Virtual profiler successfully created.';
              }, 10);
            } else {
              this.messageCreateProfiler = '';
              this.successfullCreateProfiler = true;

              setTimeout(() => {
                this.messageCreateProfiler =
                  'An error has occurred creating the virtual profiler. Please, try again later.';
              }, 10);
            }

            this.createProfilerDialog = false;
            this.creatingProfiler = false;
            this.profiler = {
              name: '',
              description: '',
              systemPrompt: '',
              STTapi: null,
              NLGapi: null,
              TTSapi: null,
              character: null,
            };
          },
          (error) => {
            this.messageCreateProfilerInside = '';
            this.messageCreateProfiler = '';

            if (error.response.status === 409) {
              this.successfullCreateProfilerInside = false;

              setTimeout(() => {
                this.messageCreateProfilerInside =
                  'Virtual profiler already in use. Please, change its name.';
              }, 10);
            } else if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullCreateProfiler = false;

              setTimeout(() => {
                this.messageCreateProfiler =
                  'An error has occurred creating the virtual profiler. Please, try again later.';
              }, 10);

              this.createProfilerDialog = false;
              this.profiler = {
                name: '',
                description: '',
                systemPrompt: '',
                STTapi: null,
                NLGapi: null,
                TTSapi: null,
                character: null,
              };
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.creatingProfiler = false;
          }
        );
      }
    },
    cancelCreateProfiler() {
      this.createProfilerDialog = false;
      this.profiler = {
        name: '',
        description: '',
        systemPrompt: '',
        STTapi: null,
        NLGapi: null,
        TTSapi: null,
        character: null,
      };
    },
    assignProfiler(item) {
      this.successfullAssignProfiler = true;
      this.messageAssignProfiler = '';

      VirtualProfilersDataService.assign(item.id).then(
        async (response) => {
          if (response.status == 200) {
            this.user.profilerId = item.id;
            await localStorage.setItem('user', JSON.stringify(this.user));
            this.user = JSON.parse(localStorage.getItem('user'));

            localStorage.removeItem('conversationId');
            this.getAllProfilers(1);

            this.messageAssignProfiler = '';
            this.successfullAssignProfiler = true;

            setTimeout(() => {
              this.messageAssignProfiler = 'Virtual profiler successfully assigned.';
            }, 10);
          } else {
            this.messageAssignProfiler = '';
            this.successfullAssignProfiler = true;

            setTimeout(() => {
              this.messageAssignProfiler =
                'An error has occurred assigning the virtual profiler. Please, try again later.';
            }, 10);
          }
        },
        (error) => {
          this.messageAssignProfiler = '';

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          } else {
            this.successfullAssignProfiler = false;

            setTimeout(() => {
              this.messageAssignProfiler =
                'An error has occurred assigning the virtual profiler. Please, try again later.';
            }, 10);
          }

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    unassignProfiler() {
      VirtualProfilersDataService.unassign().then(
        async (response) => {
          if (response.status == 204) {
            this.user.profilerId = null;
            await localStorage.setItem('user', JSON.stringify(this.user));
            this.user = JSON.parse(localStorage.getItem('user'));

            this.getAllProfilers(1);
            this.messageUnassignProfiler = '';
            this.successfullUnassignProfiler = true;

            setTimeout(() => {
              this.messageUnassignProfiler = 'Virtual profiler successfully unassigned.';
            }, 10);
          } else {
            this.messageUnassignProfiler = '';
            this.successfullUnassignProfiler = false;

            setTimeout(() => {
              this.messageUnassignProfiler =
                'An error has occurred unassigning the virtual profiler. Please, try again later.';
            }, 10);
          }
        },
        (error) => {
          this.messageUnassignProfiler = '';
          this.successfullUnassignProfiler = false;

          setTimeout(() => {
            this.messageUnassignProfiler =
              'An error has occurred unassigning the virtual profiler. Please, try again later.';
          }, 10);

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }
        }
      );
    },
    openShowDetails(profiler) {
      this.itemToShow = { ...profiler };
      this.showDetailsProfilerDialog = true;
    },
  },
};
</script>
